<div class="custom_tab_body" style="height: 100%;">
    <div class="parent_div_shipping">
        <div class="col-md-12 col-sm-12 col-12 cart_div_shipping">
            <div class="status_div_shipping">
                <div style="width: 100%;text-align: center;">
                    <span>Invoice Details</span>
                    <mat-icon class="material-icons"
                        style="float: right;height: 24px!important;font-size: 20px !important;"
                        [mat-dialog-close]="shipping">cancel</mat-icon>
                </div>
            </div>
            <div class="details_div_shipping">
                <p>Transaction Type : {{shipping?.assignedDeliveryDto?.transType}}</p>
                <p>Transaction No : {{shipping?.assignedDeliveryDto?.invNo}}</p>
                <p>Transaction Date : {{shipping?.allOrdersForDeliveryDto?.invoiceDate | date: 'yyyy-MM-dd hh:mm:ss'}}
                </p>
                <p>Amount : {{shipping?.allOrdersForDeliveryDto?.netAmt | number : '1.2-2'}}</p>
                <p>Amount To Be Paid : {{remainingAmt}}
                    <u *ngIf="remainingAmt != 0 && remainingAmt <= shipping?.allOrdersForDeliveryDto?.netAmt"
                        (click)="onPaymentClick()" style="margin-left: 50px;color: blue; cursor: pointer;">Payment</u>
                </p>
                <p>Total Items : {{shipping.noOfProducts}}</p>
                <p>Total Qty : {{shipping.qty}}</p>
                <p>Shipping Date : {{shipping?.assignedDeliveryDto?.deliveryDate | date: 'yyyy-MM-dd'}}</p>
                <p>Slot Time : {{shipping?.assignedDeliveryDto?.slot}}</p>

            </div>
        </div>
    </div>

    <div class="parent_div_shipping">
        <div class="col-md-12 col-sm-12 col-12 cart_div_shipping">
            <table>
                <tr>
                    <th>Product Name</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Total</th>
                </tr>
                <tr *ngFor="let loc of shipping.productOrderDto;let i= index" style="background-color: #c5c5c5;">
                    <td>{{loc.productName}}</td>
                    <td>{{loc.qty}}</td>
                    <td>{{loc.price | number : '1.2-2'}}</td>
                    <td>{{loc.total | number : '1.2-2'}}</td>
                </tr>
            </table>
        </div>
    </div>

    <div class="parent_div_shipping">
        <div class="col-md-12 col-sm-12 col-12 cart_div_shipping">
            <div class="status_div_shipping">
                <div style="width: 100%;text-align: center;">
                    <span>Customer Details</span>
                </div>
            </div>
            <div class="details_div_shipping">
                <span style="display: flex;">
                    <p class="p_width">Customer Name :</p>
                    <p>{{shipping.customerDto?.customerName}}</p>
                </span>
                <span style="display: flex;">
                    <p class="p_width">Customer Mobile :</p>
                    <!-- <p>{{shipping.customerDto?.customerMobile}}</p> -->
                    <p style="display: flex; align-items: center;">{{shipping.customerDto?.customerMobile}}<a
                            href="tel:{{shipping.customerDto?.customerMobile}}" target='_blank'><mat-icon
                                style="left: 6px !important; font-size: 16px !important;"> call</mat-icon></a></p>
                </span>
            </div>
        </div>
    </div>

    <div class="parent_div_shipping">
        <div class="col-md-12 col-sm-12 col-12 cart_div_shipping">
            <div class="status_div_shipping">
                <div style="width: 100%;text-align: center;">
                    <span>Shipping Details</span>
                </div>
            </div>
            <div class="details_div_shipping">
                <span style="display: flex;">
                    <p class="p_width">Customer Name :</p>
                    <p>{{shipping.customerDeliveryDetails?.contactName}}</p>
                </span>
                <span style="display: flex;">
                    <p class="p_width">Customer Mobile :</p>
                    <!-- <p>{{shipping.customerDeliveryDetails?.contactMobile}}</p> -->
                    <p style="display: flex; align-items: center;">{{shipping.customerDeliveryDetails?.contactMobile}}<a
                            href="tel:{{shipping.customerDeliveryDetails?.contactMobile}}" target='_blank'><mat-icon
                                style="left: 6px !important; font-size: 16px !important;"> call</mat-icon></a></p>
                </span>
                <span style="display: flex;">
                    <p class="p_width">Plot No/House No :</p>
                    <p>{{shipping.customerDeliveryDetails?.shippingPlotNo}}</p>
                </span>
                <span style="display: flex;">
                    <p class="p_width">Street Name :</p>
                    <p>{{shipping.customerDeliveryDetails?.shippingStreet}}</p>
                </span>
                <span style="display: flex;">
                    <p class="p_width">Landmark :</p>
                    <p>{{shipping.customerDeliveryDetails?.shippingLandMark}}</p>
                </span>
                <span style="display: flex;">
                    <p class="p_width">Pincode :</p>
                    <p>{{shipping.customerDeliveryDetails?.shippingPinCode}}</p>
                </span>
            </div>
        </div>
    </div>

    <div class="parent_div_shipping">
        <div class="col-md-12 col-sm-12 col-12 cart_div_shipping">
            <div class="details_div_shipping" style="height: 100px;padding: 2%;display: flex;">
                <div class="cam_icon_shipping">
                    <input hidden type="file" #fileUploader (change)="handleFileInput($event.target.files)"
                        accept="image/*" (click)="$event.target.value=null" />
                    <mat-icon class="material-icons" (click)="fileUploader.click();fileChooserAndroid('Camera');"
                        accept="image/*">photo_camera</mat-icon>
                </div>
                <div style="width: 40%;background-color: white;">
                    <img *ngIf="uploadImgDiv" class="previewDataImg_shipping" async src="{{uploadedSignURL}}" alt="" />
                </div>
                <div class="cam_icon_shipping" style="justify-content: flex-start;">
                    <mat-icon id="removeFile" class="material-icons" (click)="removeImg()">delete_forever</mat-icon>
                </div>
            </div>
        </div>
        <div class="div_btn">
            <button type="button" id="shipping_btn" (click)="uploadImgClick()">
                Upload image
            </button>
        </div>
    </div>
</div>